import { Form } from "antd";
import { useParams } from "react-router";

import { AppProfileCardProfilesTable } from "src/app/features/ApplicationProfile/subFeatures/CardProfile/components/tables/AppProfileCardProfilesTable";
import type { FieldMethod, FormFieldFactoryProps } from "../../types/types";
import { CreateTablePlaceholderComponent } from "../CreateTablePlaceholderComponent";

export const AppProfilesCardDefinitionsTableField: FieldMethod = ({ field, readOnly }: FormFieldFactoryProps) => {
    const { id } = useParams();

    return id ? (
        <Form.Item key={`${field.name}FormItem`} name={field.name}>
            <AppProfileCardProfilesTable key={field.name} readOnly={readOnly} />
        </Form.Item>
    ) : (
        <CreateTablePlaceholderComponent />
    );
};
